/**
 * Admin Routes
 *
 * Purpose: Routes for admin dashboard
 * Protected by AdminGuard
 */

import { Routes, Route } from 'react-router-dom'
import { AdminGuard } from '@/features/common/guards/AdminGuard'
import { AdminLayout } from '@/layouts/AdminLayout'
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage'
import { UsersPage } from '@/features/dashboard/pages/UsersPage'
import { EditUserPage } from '@/features/dashboard/pages/EditUserPage'
import { ViewUserPage } from '@/features/dashboard/pages/ViewUserPage'
import { InterestPage } from '@/features/dashboard/pages/InterestPage'
import { AddInterestPage } from '@/features/dashboard/pages/AddInterestPage'
import { EditInterestPage } from '@/features/dashboard/pages/EditInterestPage'
import { NotificationsPage } from '@/features/dashboard/pages/NotificationsPage'
import { PushNotificationPage } from '@/features/dashboard/pages/PushNotificationPage'
import { NotificationListPage } from '@/features/dashboard/pages/NotificationListPage'
import { CMSPage } from '@/features/dashboard/pages/CMSPage'
import { FAQManagementPage } from '@/features/dashboard/pages/FAQManagementPage'
import { AddFAQPage } from '@/features/dashboard/pages/AddFAQPage'
import { EditFAQPage } from '@/features/dashboard/pages/EditFAQPage'
import { AboutUsPage } from '@/features/dashboard/pages/AboutUsPage'
import { PostsPage } from '@/features/dashboard/pages/PostsPage'
import { ReportedPostsPage } from '@/features/dashboard/pages/ReportedPostsPage'
import { SettingsPage } from '@/features/dashboard/pages/SettingsPage'
import { ChangePasswordPage } from '@/features/dashboard/pages/ChangePasswordPage'
import { SupportPage } from '@/features/dashboard/pages/SupportPage'
import { KeysPage } from '@/features/dashboard/pages/KeysPage'
import { TimezonePage } from '@/features/dashboard/pages/TimezonePage'
import { AdminProfilePage } from '@/features/admin/pages/AdminProfilePage'

export function AdminRoutes() {
  return (
    <Routes>
      <Route
        element={
          <AdminGuard>
            <AdminLayout />
          </AdminGuard>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="profile" element={<AdminProfilePage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:id/edit" element={<EditUserPage />} />
        <Route path="users/:id" element={<ViewUserPage />} />
        <Route path="interest" element={<InterestPage />} />
        <Route path="interest/add" element={<AddInterestPage />} />
        <Route path="interest/:id/edit" element={<EditInterestPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="notifications/push" element={<PushNotificationPage />} />
        <Route path="notifications/send" element={<NotificationListPage />} />
        <Route path="cms" element={<CMSPage />} />
        <Route path="cms/faq" element={<FAQManagementPage />} />
        <Route path="cms/faq/add" element={<AddFAQPage />} />
        <Route path="cms/faq/:id/edit" element={<EditFAQPage />} />
        <Route path="cms/about" element={<AboutUsPage />} />
        <Route path="posts" element={<PostsPage />} />
        <Route path="posts/list" element={<PostsPage />} />
        <Route path="posts/reported" element={<ReportedPostsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/password" element={<ChangePasswordPage />} />
        <Route path="settings/support" element={<SupportPage />} />
        <Route path="settings/keys" element={<KeysPage />} />
        <Route path="settings/timezone" element={<TimezonePage />} />
      </Route>
    </Routes>
  )
}
